// @core/api/endpoints/document/release_document_lock.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Release document lock
 * Releases the editing lock on a document. Only the lock holder or an admin can release the lock.
 */
export async function ReleaseDocumentLock(
  document_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/lock`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
